import type { SearchHighlightData } from 'features/knowledgeDocumentViewer/components/viewer/search/SearchHighlightOverlay'
import type {
  FrameTarget,
  ViewerCommonProps,
} from 'features/knowledgeDocumentViewer/components/viewer/shared/types'

export type DocumentViewerInteractionProps = Pick<
  ViewerCommonProps,
  | 'highlightBoxIds'
  | 'onBoxClick'
  | 'onBoxAuxClick'
  | 'onBoxContextMenu'
  | 'onBoxHover'
  | 'onMultipleBoxSelect'
  | 'onAliasClick'
  | 'onDocReferenceClick'
  | 'onDocReferenceHover'
  | 'showTooltips'
> & {
  searchHighlights?: SearchHighlightData
  frameTarget?: FrameTarget
}

const LOCKED_DOCUMENT_VIEWER_INTERACTION_PROPS: DocumentViewerInteractionProps =
  {
    highlightBoxIds: [],
    showTooltips: false,
  }

export function getDocumentViewerInteractionProps(
  isEvalSessionLocked: boolean,
  unlocked: DocumentViewerInteractionProps
): DocumentViewerInteractionProps {
  if (isEvalSessionLocked) return LOCKED_DOCUMENT_VIEWER_INTERACTION_PROPS
  return unlocked
}
